import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-listing-header.css.lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import '../../ghs-icon/ghs-icon';

/**
 * Listing Header Component
 * @element ghs-listing-header
 */
@customElement('ghs-listing-header')
export class GhsListingHeader extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Back to top selector element.
   */
  @property({ attribute: 'back-to-top-selector' })
  backToTopSelector = 'body';

  scrollTo = () => {
    if (this.backToTopSelector) {
      document.querySelector(this.backToTopSelector)?.scrollIntoView();
    }
  };

  render(): TemplateResult {
    return html`
      <div class="listing-header">
        <div class="title">
          <slot></slot>
        </div>

        <a class="back-to-top" @click=${this.scrollTo}>
          Back to top

          <ghs-icon
            name="chevron-circle-up"
            size="30px"
            mobile-size="26px"
            site=${this.site}
          ></ghs-icon>
        </a>
      </div>
    `;
  }
}
